module.exports = __webpack_public_path__ + "img/image2.4adce893.png";